export enum SupportServerEvents {
  NEW_CONNECTION = 'connection',
  INITIAL_TICKETS = 'initial_tickets',
  NEW_TICKET = 'new_ticket',
  TICKET_UPDATED = 'ticket_updated',
  TICKET_REMOVED = 'ticket_removed',
  NEW_USER_MESSAGE = 'new_ticket_message',
  CHAT_MESSAGES = 'chat_messages',
  MESSAGE_UPDATED = 'message_updated',
  TICKET_ASSIGNED = 'ticket_assigned',
  OPERATION_ERROR = 'operation_error',
  NEW_SESSION_CONNECTED = 'new_session_connected',
  NEW_USER_REACTION = "new_user_reaction",
}

export enum SupportAgentEvents {
  CONNECTION = 'connect',
  DISCONNECTION = 'disconnect',
  CHANGE_TICKET_QUEUE = 'change_ticket_queue',
  CHANGE_TICKET_STATUS = 'change_ticket_status',
  OPEN_TICKET_CONVERSATION = 'open_ticket_conversation',
  ACCEPT_TICKET = 'accept_ticket',
  NEW_MESSAGE = 'new_message',
  GET_CHAT_MESSAGES = 'get_chat_messages',
  GET_CHAT_MESSAGE = 'get_chat_message',
  REOPEN_TICKET = 'reopen_ticket',
  CREATE_TICKET = 'create_ticket',
  MARK_TICKET_AS_READ = "mark_ticket_as_read",
}
